import { Alerta, Button, Card, Logo2M, Stack, TextField } from "@/components";
import type { Usuario } from "@/lib/api";
import { MIN_PASSWORD } from "@/lib/usuarios";
import { usePrimerIngresoTab } from "./usePrimerIngresoTab";

export interface PrimerIngresoTabProps {
  usuario: Usuario;
  /** Vuelve a pedir /api/auth/yo después de guardar. */
  onListo: () => Promise<void>;
  onSalir: () => void;
}

/** Entró con la contraseña temporal: hasta elegir la suya no ve nada más. */
export function PrimerIngresoTab({ usuario, onListo, onSalir }: PrimerIngresoTabProps) {
  const t = usePrimerIngresoTab(onListo);
  return (
    <div className="grid min-h-dvh place-items-center px-4 py-10">
      <div className="w-full max-w-sm">
        <Stack espacio={6}>
          <div className="flex justify-center text-carbon">
            <Logo2M className="w-32" />
          </div>
          <Card>
            <form onSubmit={(e) => void t.enviar(e)} noValidate>
              <Stack espacio={4}>
                <Stack espacio={1}>
                  <h1 className="text-pantalla font-light tracking-[-0.03em]">Hola, {usuario.nombre}</h1>
                  <p className="text-texto-suave">Entraste con una contraseña temporal. Elegí la tuya para seguir.</p>
                </Stack>
                <TextField etiqueta="Email" type="email" autoComplete="username" value={usuario.email} readOnly disabled />
                <TextField
                  etiqueta="Contraseña nueva"
                  type="password"
                  autoComplete="new-password"
                  ayuda={`Mínimo ${MIN_PASSWORD} caracteres`}
                  value={t.password}
                  onChange={(e) => t.setPassword(e.target.value)}
                />
                <TextField
                  etiqueta="Repetí la contraseña"
                  type="password"
                  autoComplete="new-password"
                  value={t.repetida}
                  onChange={(e) => t.setRepetida(e.target.value)}
                />
                <Alerta texto={t.error} />
                <Button type="submit" anchoCompleto cargando={t.guardando}>
                  Guardar y entrar
                </Button>
                <Button variante="fantasma" anchoCompleto onClick={onSalir}>
                  Salir
                </Button>
              </Stack>
            </form>
          </Card>
        </Stack>
      </div>
    </div>
  );
}
